import React, { useState, useMemo, useRef, useEffect } from 'react';
import { Menu, Button, Drawer, theme, Input, Space, Tooltip, Row, Col, Card, Typography, Layout, Select } from 'antd';
import {
    MenuOutlined,
    HomeOutlined,
    DashboardOutlined,
    RocketOutlined,
    BarChartOutlined,
    LineChartOutlined,
    PieChartOutlined,
    ExperimentOutlined,
    BugOutlined,
    FilterOutlined
} from '@ant-design/icons';
import { ChevronDown, ChevronUp, Download, Fuel, Settings, Ship } from 'lucide-react';
import "./chart.css";
import { NavLink, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import superuserService from '@/services/superadminService';
import html2canvas from "html2canvas";
import ownerService from '@/services/ownerService';
import FilterTags from '../Ownerpage/Charts/FilterTags';
import { pdf, PDFDownloadLink } from '@react-pdf/renderer';
import SeaFlashPDF from '../Ownerpage/Charts/ChartPrint';
import CommonChart from './CommonChart';
import ChartFilter from '../Ownerpage/Charts/ChartFilter';
import chartService from '@/services/chartService';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { toJpeg, toPng } from 'html-to-image';
import { apiUrl } from '@/services/axiosConfig';
import ChartHeader from './Charts/ChartHeader';
const { Title, Text } = Typography;
const { Content, Header } = Layout;


const parseUrlFilters = (imo_number, period, searchParams) => {
    if (!imo_number || !period) return null;

    const startDate = searchParams.get('startDate');
    const endDate = searchParams.get('endDate');

    let dateFilter = { type: '', value: '' };

    switch (period) {
        case 'year':
            dateFilter = { type: 'Yearly', value: 'Yearly' };
            break;
        case 'month':
            dateFilter = { type: 'Monthly', value: 'Monthly' };
            break;
        case 'week':
            dateFilter = { type: 'Weekly', value: 'Weekly' };
            break;
        case 'quarter':
            dateFilter = { type: '3Months', value: '3Months' };
            break;
        case 'custom':
        case 'date':
            if (startDate && endDate) {
                dateFilter = { type: 'Range', value: [startDate, endDate] };
            }
            break;
        default:
            dateFilter = {
                type: 'Range',
                value: startDate && endDate ? [startDate, endDate] : []
            };
    }

    return {
        ship_id: imo_number,
        date: dateFilter,
        eu_noneu: { from: '', to: '' },
        events: [],
        voyage: null
    };
};

export default function ChartApplication({ topOffset = 0, initialCollapsed = false }) {
    const [collapsed, setCollapsed] = useState(initialCollapsed);
    const navigate = useNavigate()
    const [openKeys, setOpenKeys] = useState([]);
    const [mobileVisible, setMobileVisible] = useState(false);
    const [generalCharts, setGeneralCharts] = useState([]);
    const [isGeneratingPDF, setIsGeneratingPDF] = useState(false)
    const chartRefs = useRef({});
    const chartloader = useRef(false);
    const { token } = theme.useToken();
    const [isMobile, setIsMobile] = useState(false);
    const [pdfData, setPdfData] = useState(null);
    const [filterCollapsed, setFilterCollapsed] = useState(false);
    const [loading, setLoading] = useState(false);
    const [allEvents, setAllEvents] = useState([]);
    const [chartlist, setChartlist] = useState([]);
    const [shiplist, setShiplist] = useState([]);
    const [selectedFavourite, setSelectedFavourite] = useState(null)
    const printRef = useRef();
    const [downloadProgress, setDownloadProgress] = useState({ current: 0, total: 0, status: '' });
    const [searchParams] = useSearchParams(); // Add this line

    const [filteredProcessdata, setFilterProcessData] = useState({
        ship_id: "",
        date: null,
        eu_noneu: { from: "", to: "" },
        events: [],
        voyage: null,
    });
    const [groupedCharts, setGroupedCharts] = useState({});
    const { reportType, topic, imo_number, period } = useParams();

    function groupByGroupName(charts) {
        const grouped = charts.reduce((acc, chart) => {
            const groupName = chart.group?.group_name;
            if (groupName) {
                if (!acc[groupName]) {
                    acc[groupName] = [];
                }
                acc[groupName].push(chart);
            }
            return acc;
        }, {});

        const allCharts = Object.values(grouped).flat();

        // ✅ Create a new object with "All Reports" first
        const groupedWithAllReportsFirst = {
            "All Reports": allCharts,
            ...grouped
        };

        return groupedWithAllReportsFirst;
    }


    useEffect(() => {
        const urlFilters = parseUrlFilters(imo_number, period, searchParams);

        if (urlFilters) {
            console.log('Applying URL filters:', urlFilters);
            setFilterProcessData(urlFilters);

            // Show filter panel to display applied filters
            setFilterCollapsed(true);
        }
    }, [imo_number, period, searchParams]);

    const chartfavouritelist = (charts) => {
        const groupMap = {};

        charts.forEach((chart) => {
            const groupName = chart.group?.group_name;
            if (groupName) {
                const groupId = chart.group?.id || groupName; // Prefer group.id if it's unique

                if (!groupMap[groupName]) {
                    groupMap[groupName] = {
                        id: groupId,
                        name: groupName,
                        charts: []
                    };
                }

                groupMap[groupName].charts.push({
                    id: chart.chart_id,
                    name: chart.chart_title,
                    chart_comments: chart.chart_comments
                });
            }

        });

        return Object.values(groupMap);
    };

    const fetchChartData = async () => {
        chartloader.current = true;
        try {
            const chartinfo = await superuserService.getownersCharts(reportType);
            if (chartinfo?.data) {
                const nonGeneralCharts = chartinfo?.data?.filter(
                    (x) => x?.variant !== "GENERAL"
                );
                const gernalCharts = chartinfo?.data?.filter(
                    (x) => x?.variant === "GENERAL"
                );

                // const grouped = groupByTopic(nonGeneralCharts);
                const grouped = groupByGroupName(nonGeneralCharts);
                console.log("grouped", grouped)
                setChartlist(chartfavouritelist(nonGeneralCharts))
                setGroupedCharts(grouped);
                setGeneralCharts(gernalCharts);

            } else {
                chartloader.current = false;
            }
        } catch (err) {
            console.log(err);
        } finally {
            chartloader.current = false;
            setFilterCollapsed(false);
        }
    };
    useEffect(() => {
        setPdfData(null)
    }, [topic])
    console.log("Sfsdfsd")
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);
            if (mobile) {
                setCollapsed(true);
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const getallEvents = async () => {
        const { data } = await superuserService.getAllEvents();
        let eventsdetails = [];
        if (data?.length) {
            eventsdetails = data?.map((x) => {
                return {
                    value: x?.event_type,
                    label: x?.event_type,
                };
            });
            setAllEvents(eventsdetails);
        }
    };

    function createMenuItems(groupedCharts) {
        return Object.entries(groupedCharts).map(([groupName, submenus]) => ({
            key: groupName,
            icon: <PieChartOutlined />,
            label: groupName,
        }));
    }
    const menuItems = useMemo(() => createMenuItems(groupedCharts), [groupedCharts]);
    const handleOpenChange = (keys) => setOpenKeys(keys);


    useEffect(() => {
        fetchChartData();
        getallEvents();
        // return () => {
        //     setFilterProcessData({
        //         date: { type: "", value: "" },
        //         eu_noneu: { from: "", to: "" },
        //         events: [],
        //         voyage: null,
        //     });
        // };
    }, [reportType, selectedFavourite]);



    const captureChartWithHtml2Canvas = async (element) => {
        if (!element) return null;

        try {
            // Hide tooltips or unnecessary floating UI
            element.querySelectorAll(".apexcharts-tooltip, .ant-tooltip, [data-html2canvas-ignore]")
                .forEach((el) => el.style.display = "none");

            // Wait for any animations to complete
            await new Promise(resolve => setTimeout(resolve, 100));

            const canvas = await html2canvas(element, {
                useCORS: true,
                backgroundColor: "#ffffff",
                scale: 2,
                removeContainer: true,
                logging: false,
                scrollY: -window.scrollY,
                allowTaint: true,
                foreignObjectRendering: false, // Better for complex charts
                imageTimeout: 15000, // Increased timeout for complex charts

            });

            return canvas.toDataURL("image/png");
        } catch (err) {
            console.error("❌ Chart capture with html2canvas failed:", err);
            return null;
        }
    };

    // Fast html-to-image capture for simple elements (tables, summaries, comments)
    const captureSimpleElementWithHtmlToImage = async (element) => {
        if (!element) return null;

        try {
            // Hide tooltips
            const elementsToHide = element.querySelectorAll(".apexcharts-tooltip, .ant-tooltip, [data-html2canvas-ignore]");
            elementsToHide.forEach((el) => {
                el.style.display = "none";
                el.setAttribute('data-was-hidden', 'true');
            });

            const dataUrl = await toPng(element, {
                quality: 0.85,
                pixelRatio: 1.2,
                backgroundColor: '#ffffff',
                cacheBust: false,
                skipAutoScale: true,
                width: element.offsetWidth,
                height: element.offsetHeight,
                style: {
                    transform: 'scale(1)',
                    transformOrigin: 'top left'
                }
            });

            // Restore hidden elements
            elementsToHide.forEach((el) => {
                if (el.getAttribute('data-was-hidden')) {
                    el.style.display = "";
                    el.removeAttribute('data-was-hidden');
                }
            });

            return dataUrl;
        } catch (err) {
            console.error("❌ Simple element capture failed, falling back to JPEG:", err);

            // Fallback to JPEG
            try {
                const fallbackDataUrl = await toJpeg(element, {
                    quality: 0.8,
                    pixelRatio: 1,
                    backgroundColor: '#ffffff'
                });
                return fallbackDataUrl;
            } catch (fallbackErr) {
                console.error("❌ Fallback capture also failed:", fallbackErr);
                return null;
            }
        }
    };

    // Detect if element is likely a chart based on common chart libraries
    const isChartElement = (element) => {
        if (!element) return false;

        const chartSelectors = [
            '.apexcharts-canvas',
            '.highcharts-container',
            '.plotly-graph-div',
            '.d3-chart',
            '.chart-container',
            '.chartjs-render-monitor',
            'canvas',
            'svg[class*="chart"]',
            '[class*="chart"]canvas',
            '.viz',
            '.visualization'
        ];

        // Check if element itself matches chart selectors
        const isChart = chartSelectors.some(selector => {
            try {
                return element.matches(selector) || element.querySelector(selector);
            } catch (e) {
                return false;
            }
        });

        // Additional checks for common chart attributes
        const hasChartAttributes = element.dataset?.chart ||
            element.dataset?.chartType ||
            element.classList?.toString().includes('chart') ||
            element.tagName === 'CANVAS';

        return isChart || hasChartAttributes;
    };

    // Hybrid capture function
    const captureElementAsImage = async (element, elementType = 'auto') => {
        if (!element) return null;

        try {
            let shouldUseHtml2Canvas = false;

            // Determine capture method based on element type or auto-detection
            if (elementType === 'chart' || (elementType === 'auto' && isChartElement(element))) {
                shouldUseHtml2Canvas = true;
                console.log('📊 Using html2canvas for chart element');
            } else {
                console.log('📋 Using html-to-image for simple element');
            }

            // Use appropriate capture method
            if (shouldUseHtml2Canvas) {
                return await captureChartWithHtml2Canvas(element);
            } else {
                return await captureSimpleElementWithHtmlToImage(element);
            }
        } catch (err) {
            console.error("❌ Hybrid capture failed:", err);
            return null;
        }
    };

    // Batch process with intelligent method selection
    const processImagesInBatches = async (chartRefsArray, batchSize = 2) => {
        const results = [];

        for (let i = 0; i < chartRefsArray.length; i += batchSize) {
            const batch = chartRefsArray.slice(i, i + batchSize);

            const batchResults = await Promise.all(
                batch.map(async ([id, { chartEl, tableEl, summaryEl, commentsEl }]) => {
                    try {
                        // Use html2canvas for chart elements (slower but more reliable)
                        const chartImage = chartEl ? await captureElementAsImage(chartEl, 'chart') : null;

                        // Small delay between captures
                        await new Promise(resolve => setTimeout(resolve, 100));

                        // Use html-to-image for other elements (faster)
                        const tableImage = tableEl ? await captureElementAsImage(tableEl, 'table') : null;
                        await new Promise(resolve => setTimeout(resolve, 50));

                        const summaryImage = summaryEl ? await captureElementAsImage(summaryEl, 'summary') : null;
                        await new Promise(resolve => setTimeout(resolve, 50));

                        const commentImage = commentsEl ? await captureElementAsImage(commentsEl, 'comment') : null;

                        const chartInfo = groupedCharts[topic]?.[id] || {};
                        if (chartInfo?.chart_title) {
                            return {
                                chartTitle: chartInfo.chart_title,
                                chartSubtitle: chartInfo.chart_subtitle || "",
                                chartDescription: chartInfo.descriptions || "",
                                chartImage,
                                summaryImage,
                                tableImage,
                                commentImage
                            };
                        }
                        return null;
                    } catch (err) {
                        console.error(`❌ Failed to process chart ${id}:`, err);
                        return null;
                    }
                })
            );

            results.push(...batchResults);

            // Delay between batches to prevent memory issues
            if (i + batchSize < chartRefsArray.length) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
        }

        return results;
    };

    // Optimized PDF generation with hybrid approach
    const handleGeneratePDF = async () => {

        const chartRefsArray = Object.entries(chartRefs.current);
        setIsGeneratingPDF(true);

        try {
            const ship_id = filteredProcessdata?.ship_id || localStorage.getItem("imo_number");

            console.log('🚀 Starting hybrid PDF generation...');
            const startTime = performance.now();

            // Run API call and image processing in parallel
            const [getChartmeta, chartdetails,] = await Promise.all([
                ownerService.getchartmetadetails(topic, ship_id),
                processImagesInBatches(chartRefsArray, 2) // Process 2 charts at a time
            ]);
            const processingTime = ((performance.now() - startTime) / 1000).toFixed(2);
            console.log(`✅ Image processing completed in ${processingTime}s`);

            const shipinfo = getChartmeta?.data?.shipDetail;
            const engineinfo = getChartmeta?.data?.engineDetail;
            const shipimg = getChartmeta?.data?.shipimg;
            console.log("shipimgshipimg", shipimg)

            setPdfData({
                shipDetail: {
                    name: shipinfo?.name,
                    imoNumber: shipinfo?.imoNumber,
                    type: shipinfo?.type,
                    flag: shipinfo?.flag,
                    ownerCode: shipinfo?.ownerCode || "SEA-001"
                },
                engineDetail: {
                    type: engineinfo?.type,
                    model: engineinfo?.model,
                    power: engineinfo?.power,
                    grossTonnage: engineinfo?.grossTonnage,
                    deadweight: engineinfo?.deadweight
                },
                shipimg: `${apiUrl}${shipimg}` || "",
                reportName: topic == "All Reports" ? "Reports" : topic,
                chartdetails: chartdetails.filter(Boolean)
            });

            const totalTime = ((performance.now() - startTime) / 1000).toFixed(2);
            console.log(`🎉 Total PDF generation completed in ${totalTime}s`);

        } catch (error) {
            console.error("PDF generation failed:", error);
        } finally {
            setIsGeneratingPDF(false);
        }
    };

    const selectedLabel = useMemo(() => {
        // flatten menuItems to find label
        const stack = [...menuItems];
        while (stack.length) {
            const item = stack.pop();
            if (item.key === topic) return item.label;
            if (item.children) stack.push(...item.children);
        }
        return '';
    }, [menuItems, topic]);

    const getselectedSubmenu = (key) => {
        return menuItems.find(item => item.key == topic)?.label
    }
    const setFavouriteSetting = async (e) => {
        const chartfilterlist = await chartService.getFavouritebyId(e.favorite_name)
        const { date, eu_noneu, events, voyage } = chartfilterlist?.data[0]?.filter_configuration

        setFilterProcessData({
            date: date,
            eu_noneu,
            events,
            voyage
        })
        setSelectedFavourite(chartfilterlist?.data)

    }
    useEffect(() => {
        const shiplist = async () => {
            const shiplistdata = await ownerService.getShipDetails();
            setShiplist(shiplistdata?.data);
        };

        shiplist();
    }, []);
    return (
        <>
            {/* Main Column */}
            <div className="sidebar-page-content">

                <ChartHeader
                    // Report type — from your route param
                    reportType={reportType}
                    // Active topic — from your route param  
                    topic={topic}
                    // Menu items array from your component
                    menuItems={menuItems}
                    // Ship list for the ship selector
                    shiplist={shiplist}
                    // Filter state
                    filteredProcessdata={filteredProcessdata}
                    setFilterProcessData={setFilterProcessData}
                    // Favorites
                    chartlist={chartlist}
                    allEvents={allEvents}
                    setFavouriteSetting={setFavouriteSetting}
                    // Filter panel toggle
                    filterCollapsed={filterCollapsed}
                    setFilterCollapsed={setFilterCollapsed}
                    // PDF geeration
                    isGeneratingPDF={isGeneratingPDF}
                    handleGeneratePDF={handleGeneratePDF}
                    pdfData={pdfData}
                />

                <div className="sidebar-page-scroll">
                    <Content
                        style={{
                            borderRadius: token.borderRadius,
                            overflow: "auto",
                        }}
                    >  {filterCollapsed && (
                        <Card
                            size="small"
                            style={{
                                marginBottom: "16px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                background: "linear-gradient(135deg,  #3CA690 0%,#B3E2C6 100%)",
                                borderRadius: "8px",
                            }}
                            title={
                                <Title
                                    className="text-white"
                                    level={5}
                                    style={{ margin: 0, display: "flex", alignItems: "center" }}
                                >
                                    <FilterOutlined className="me-3 text-white" />
                                    Filter Options
                                </Title>
                            }
                            extra={
                                <Button
                                    size="small"
                                    icon={<FilterOutlined className="text-white" />}
                                    type="primary"
                                    onClick={fetchChartData}
                                    loading={loading}
                                >
                                    Apply Filters
                                </Button>
                            }
                        >
                            <ChartFilter
                                topic={topic}
                                setFilterProcessData={setFilterProcessData}
                                filteredProcessdata={filteredProcessdata}
                                filterOptions={allEvents}
                                shiplist={shiplist}
                            />
                        </Card>
                    )}
                        {loading ? (
                            <Loader position="center" />
                        ) : (
                            <div className="hidden-overflow" ref={printRef}>
                                <Row gutter={[16, 16]} style={{ marginBottom: "10px" }}>
                                    {generalCharts?.map((x, id) => (
                                        <Col span={x?.chart_style} key={id} >

                                            <CommonChart
                                                key={id}
                                                classNames="common-header"
                                                chartinfo={x}
                                                filterData={filteredProcessdata}
                                            />
                                        </Col>
                                    ))}
                                </Row>
                                <Row gutter={[16, 16]} >
                                    {console.log("groupedCharts[topic]", groupedCharts[topic])}
                                    {groupedCharts[topic]?.length ? (
                                        groupedCharts[topic].map((x, id) => (
                                            <Col span={x?.chart_style} key={id}
                                                id={x?.chart_title}
                                            >
                                                {x ? (
                                                    <CommonChart
                                                        key={id}
                                                        chartinfo={x}
                                                        classNames="app"
                                                        selectedTopic={topic}
                                                        filterData={filteredProcessdata}
                                                        ref={(el) => {
                                                            if (el) {
                                                                chartRefs.current[id] = el;
                                                            }
                                                        }}
                                                        selectedFavourite={selectedFavourite}

                                                    />
                                                ) : (
                                                    ""
                                                )}
                                            </Col>
                                        ))
                                    ) : (
                                        ""
                                    )}
                                </Row>

                            </div>
                        )}

                        <>
                            {!topic &&
                                <>
                                    <div
                                        style={{
                                            textAlign: "center",
                                            padding: "80px 20px",
                                            color: token.colorTextSecondary,
                                        }}
                                    >
                                        <PieChartOutlined
                                            style={{ fontSize: "64px", marginBottom: "16px" }}
                                        />
                                        <Title level={4} type="secondary">
                                            {!Object.keys(groupedCharts)?.length
                                                ? "No Chart Reports Found"
                                                : "Select Your Charts"}
                                        </Title>
                                        <Text type="secondary">
                                            Choose a topic from the sidebar to view related charts
                                        </Text>
                                    </div>
                                </>
                            } </>
                    </Content>
                </div>
            </div>
        </>
    );
}